import React from 'react';

import WalletPage from '../../components/checkoutPages/wallet';

function Checkout() {

  // const [currentStep, setCurrentStep] = React.useState(1);

  // const goToNextStep = () => {
  //   setCurrentStep(currentStep + 1);
  // };

  // const goToStep = (step) => {
  //   setCurrentStep(step);
  // };

  return (
    <>
      <div className='max-w-[1300px] mx-auto mt-40'>
        {/* <CheckoutStepper currentStep={currentStep} goToStep={goToStep} />
        {
          currentStep === 1 ? <CartPage goToNextStep={goToNextStep} /> : currentStep === 2 ? <SummaryPage goToNextStep={goToNextStep} /> : <WalletPage />
        } */}
        <WalletPage />
      </div>
    </>
  );
}

export default Checkout;
